import { StepperDesignTokens } from '@primeuix/themes/aura/stepper';

export const stepperTokens: StepperDesignTokens = {
  root: {
    transitionDuration: '{transition.duration}',
  },
  separator: {
    background: '{content.border.color}',
    activeBackground: '{primary.color}',
    margin: '0 0 0 1rem',
    size: '2px',
  },
  step: {
    padding: '0.5rem',
    gap: '1rem',
  },
  stepHeader: {
    padding: '0',
    borderRadius: '{content.border.radius}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    gap: '0.5rem',
  },
  stepTitle: {
    color: '{text.muted.color}',
    activeColor: '{primary.color}',
    fontWeight: '500',
  },
  stepNumber: {
    background: '{content.background}',
    activeBackground: '{content.background}',
    activeBorderColor: '{content.border.color}',
    activeColor: '{primary.color}',
    borderColor: '{content.border.color}',
    borderRadius: '{stepper.step.number.size} / 2',
    color: '{text.muted.color}',
    size: '2rem',
    fontSize: '1.143rem',
    fontWeight: '500',
    shadow: '0 0.5px 0 0 rgba(0, 0, 0, 0.06), 0 1px 1px 0 rgba(0, 0, 0, 0.12)',
  },
  steppanels: {
    padding: '0.875rem 0.5rem 1.125rem 0.5rem',
  },
  steppanel: {
    background: '{content.background}',
    color: '{content.color}',
    padding: '0 0 0 1rem',
  },
};
